import ChartApi from '../data/api/chart-api';

class ChartRepository {
  constructor() {
    this.api = new ChartApi();
  }

  getHistoryExchange(base, against, start, end) {
    return this.api.getHistoryExchange(base, against, start, end);
  }
}

export default ChartRepository;
